/** used as enum for size input field */
export enum ESize {
  xs = 'xs',
  sm = 'sm',
  /** used as default */
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}
